import { darkTheme, theme } from '@/theme.ts';
import { MantineProvider } from '@mantine/core';
import { ConfigCatProvider, DataGovernance, PollingMode } from 'configcat-react';

import { Router } from '@/components/router.tsx';

import { featureFlagOverrides } from '@/constants/feature-flag-overrides.ts';

import { useLoadUser } from '@/hooks/use-load-user.ts';

import { ColorTheme } from '@/models/color-theme.ts';

import { useThemeStore } from '@/stores/theme-store.ts';

import { getConfigCatSdkKey } from '@/utils/env-utils.ts';

const configCatSdkKey = getConfigCatSdkKey();

if (!configCatSdkKey) {
    console.warn(
        'VITE_CONFIG_CAT_SDK_KEY is missing — rendering without ConfigCatProvider; feature flags will fall back to their default values.'
    );
}

export const App = () => {
    useLoadUser();
    const { theme: colorTheme } = useThemeStore();

    const appTree = (
        <MantineProvider theme={colorTheme === ColorTheme.LIGHT ? theme : darkTheme}>
            <Router />
        </MantineProvider>
    );

    if (!configCatSdkKey) {
        return appTree;
    }

    return (
        <ConfigCatProvider
            sdkKey={configCatSdkKey}
            pollingMode={PollingMode.AutoPoll}
            options={{ flagOverrides: featureFlagOverrides, dataGovernance: DataGovernance.EuOnly }}
        >
            {appTree}
        </ConfigCatProvider>
    );
};
